import { api } from 'utility';
import { getProductSearchUrl } from 'URLs';
export function getProducts(params) {
  return api.get(getProductSearchUrl(), { params }).then((res) => res.data);
}

export default { getProducts };
